import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: BACKEND_URL,
  withCredentials: true,
});

// On 401, renew the session once via the refresh cookie and retry; if that
// fails (expired, or the password was changed) send the user to sign in.
const AUTH_PATHS = ["/api/auth/login", "/api/auth/refresh", "/api/auth/me", "/api/auth/logout"];
let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config || {};
    const status = error.response?.status;
    if (status !== 401 || cfg._retried || AUTH_PATHS.some((p) => (cfg.url || "").includes(p))) {
      return Promise.reject(error);
    }
    try {
      refreshing = refreshing || api.post("/api/auth/refresh", {});
      await refreshing;
    } catch {
      if (!window.location.pathname.startsWith("/login")) window.location.assign("/login");
      return Promise.reject(error);
    } finally {
      refreshing = null;
    }
    return api({ ...cfg, _retried: true });
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
